<template>
  <el-dialog :title="type == 1 ? '加价寄件人付费返佣' : '不加价寄件人付运费'" :visible.sync="dialogVisible" :before-close="closeDialog"
    append-to-body width="600px" :close-on-click-modal="false">
    <div class="content">
      <!-- 大图区 -->
      <div class="big-img">
        <img class="img" v-if="type == 1" src="@/assets/images/returnPickupPrint/pic_TipsFY.png" alt="">
        <img class="img" v-if="type == 2" src="@/assets/images/returnPickupPrint/pic_TipsBJJ.png" alt="">
      </div>
      <div class="content-detail" v-if="type == 1">
        <div class="big-title y-p-r">
          <span>佣金设置：</span>
        </div>
        <div class="y-mt-10 padding-left9">
          <span class="span-text">在现有管家报价的基础上，每单加价</span>
          <el-input-number class="y-ml-10" v-model="brokerage" :precision="1" :step="0.5" :min="0.5" :max="2.0"
            size="small" :step-strictly="true">
          </el-input-number>
          <span class="span-text y-ml-10">元佣金设置</span>
        </div>
        <div class="big-title y-p-r y-mt-10">
          <span>返佣规则：</span>
        </div>
        <div class="padding-left9 y-mt-10">
          <span class="span-text">以业务员揽收重量为准，收取寄件人费用；待订单签收后，将加价金额返佣到您的个人支付宝账号。</span>
        </div>
        <div class="padding-left9 y-mt-10 ali-name-box dis-center justify-content-between">
          <div class="dis-center">
            <span class="yuan1"></span>
            <span class="span-text y-ml-10">当前已绑定的支付宝收款人 : </span>
            <span class="span-text1">{{ alipayName?alipayName:'未绑定' }}</span>
          </div>

          <div class="dis-center y-mr-15">
            <template  v-if="isRealNameInfo.cerName">
              <el-popover
                placement="right"
                width="400"
                trigger="click">
                <div class="real-popover-box">
                  <div class="real-popover-title">查看实名</div>
                  <div class="y-pb-15">
                    <div class="tip-txt"><img class="icon-tip" src="@/assets/images/icon/warning_icon.png" alt="">当前实名信息为维护支付宝账号的客户管家账号实名信息</div>
                    <div class="real-name-content">
                      <div >
                        <span class="real-name-label">姓名 :</span> <span class="span-text">{{ isRealNameInfo.cerName }}</span>
                      </div>
                      <div class="margin-top-8">
                        <span class="real-name-label">证件类型 :</span> <span class="span-text">{{ isRealNameInfo.cerTypeName }}</span>
                      </div>
                      <div class="margin-top-8">
                        <span class="real-name-label">证件号码 :</span> <span class="span-text">{{ isRealNameInfo.cerNo }}</span>
                      </div> 
                    </div>
                                  
                  </div>
                </div>
                <span slot="reference" class="change-account systemColor y-c-p look-content">查看实名</span>
              </el-popover>
            </template>  
            <span class="y-ml-10 y-mr-10 systemColor" v-if="isRealNameInfo.cerName">|</span>          
            <span class="change-account y-ml-10 y-c-p systemColor" type="primary" size="small" @click="openSaveAccount">{{ alipayName?'更换账号' : '去绑定' }}</span>
           


            <!-- <span class="change-account  y-c-p systemColor" type="primary" size="small" v-if="!isRealNameInfo.cerName" @click="goToRealNameFn">去实名</span> -->
          </div>

        </div>
        <div class="padding-left9 y-mt-10 dis-center">
            <span class="yuan2"></span> <span class="span-text-red  y-ml-10">提示 : 支付宝账号实名信息需与维护支付宝账号的客户管家账号实名信息一致，否则会打款失败。 </span>   
        </div>
      </div>
      <div class="content-detail" v-if="type == 2">
        <div class="big-title y-p-r">
          <span>业务规则：</span>
        </div>
        <div class="padding-left9 y-mt-10">
          <span class="span-text">以业务员揽收重量为准，按管家的报价和商家设置的付款方式，由寄件人承担运费或寄件人与商家共同承担运费。</span>
        </div>
      </div>      
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">我知道了</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { searchAlipayBindApi,searchRealNameInfoApi } from '@/api/waybillPrint/returnPickupPrint'
export default {
  name: "record-list",
  props: {
    // realNameId: {
    //   type: String,
    //   default: '',
    // },
    // alipayName:{
    //   type: String,
    //   default: '',
    // },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isRealNameInfo:{},
      alipayName:'',
      realNameId:'',
      brokerage: 0.5,
      dialogVisible: this.isShow,
      type: '',
    };
  },
  watch:{
    brokerage(val) {
      this.$emit('changeBrokerage',val);
    }
  },
  methods: {
    UpDateAlyName(userName){
      this.alipayName = userName;
    },
    searchRealNameInfoFn(){
      searchRealNameInfoApi({}).then(res=>{
        if(res.message=='ok'&&res.data){
          this.isRealNameInfo = res.data;
        }
        
      })
    },    
    lookRealNameFn(){

    },
    goToRealNameFn(){
      this.$emit('goToRealName')
    },
    searchAlipayBindFn(){
      searchAlipayBindApi({}).then(res=>{
        if(res.message=='ok'&&res.data){
          //有支付宝账号说明已经实名
          if(res.data.userName){
            this.alipayName = res.data.userName;
            this.realNameId = res.data.realNameId;
            //获取实名信息
            this.searchRealNameInfoFn();
          }else{
            if(res.data.realNameId){
              this.realNameId = res.data.realNameId;
              this.searchRealNameInfoFn();
            }
          }


        }else{
        }
      }).catch(err=>{
      })
    },      
    openSaveAccount(){
      console.log('this.realNameId',this.realNameId)
      this.$emit('openSaveAccount',this.realNameId);
    },
    initData(type,brokerage) {
      this.type = type;
      if(type==1){
        this.brokerage = brokerage||0.5;
        this.searchAlipayBindFn();
      }
    },
    closeDialog(refresh) {
      this.dialogVisible = false;
      this.$emit("closeDialog", refresh);
    },

  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.big-title {
  letter-spacing: 1px;
  padding-left: 10px;
  font-weight: 800;
  font-size: 14px;
  color: #333333;
}

.big-title::before {
  content: " ";
  position: absolute;
  left: 0px;
  top: 2px;
  width: 2px;
  height: 12px;
  background: #653EB3;
}
.yuan1{
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #653EB3;
  border-radius: 50%;
}
.yuan2{
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #FF4D4F;
  border-radius: 50%;
}
.span-text {
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: #151719;
}

.span-text1 {
  letter-spacing: 1px;
  font-weight: 400;
  font-size: 14px;
  color: #222222;
}
.span-text-red{
  font-weight: 500;
  font-size: 14px;
  color: #FF4D4F;  
}
.content {
  width: 100%;
}

.big-img {
  width: 100%;

  .img {
    width: 100%;
  }
}

.change-account {
  display: inline-block;

  img {
    vertical-align: middle;
    width: 16px;
  }
}

.padding-left9 {
  padding-left: 9px;
}
.ali-name-box{
  height: 26px;
  background: rgba(101, 62, 179, 0.08);
  border-radius: 2px;
}
.justify-content-between {
  justify-content: space-between;  
}
.dis-center{
    display: flex;
    align-items: center;  
}
.content-detail {
  padding-top: 24px;
  margin-top: 24px;
  border-top: 1px solid #EDEDED;
  ;
}
/deep/ .el-dialog__footer {
  text-align: right;
  border-top: 1px solid #EDEDED;
}
/deep/ .el-cascader.el-cascader--small {
  width: 100%;
}

/deep/ .el-dialog__footer {
  text-align: center;
}
.real-popover-box{
  .real-popover-title{
    font-weight: 500;
    font-size: 16px;
    color: #151719;
    text-align: center;
    box-shadow: inset 0px -1px 0px 0px #D7DBDF;    
    padding-bottom: 11px;
  }
  .icon-tip{
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }
  .tip-txt{
    font-weight: 400;
    font-size: 14px;
    color: #FF4D4F;
    display: flex;
    align-items: center;
    padding: 16px 0;

  }
  .real-name-content{
    height: 76px;
    padding: 12px;
    background: #F2F3F4;
    border-radius: 4px;    
  }
  .real-name-label{
    font-size: 14px;
    color: #52585F;
    line-height: 20px;
    display: inline-block;
    text-align: right;
    width: 80px;
  }
  .margin-top-8{
    margin-top: 8px;    
  }
}
</style>